export enum TighteningMethod {
    Torque = 0,
    Tension = 1,
}
